export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            backgroundColor: props?.BackgroundBrandColorPicker && props?.BackgroundBrandColorPicker !== '' ? props?.BackgroundBrandColorPicker : '#E4E4E4'
        }
    })
}
